'use client'

import { Col, CopyButton, Row, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { CryptoQrCodeButton } from './crypto.qr-code-button'

interface CryptoOutputItemProps {
  title: string
  value: string
  isCopyable?: boolean
  description?: string
  networkName?: string
  networkBadge?: string
  networkIcon?: React.ReactNode
}

export const CryptoOutputItem = ({
  title,
  value,
  description,
  isCopyable = true,
  networkName,
  networkBadge,
  networkIcon,
}: CryptoOutputItemProps) => {
  const { t } = useTranslate()

  return (
    <Col className='gap-2xs'>
      <Typography size='xs' weight='bold' color='text-neutral-surface-100'>
        {title}
      </Typography>

      <Row className='gap-md justify-between border border-neutral-surface-dark rounded-xs min-h-10 py-xs md:py-2xs  ps-md pe-2xs'>
        <Typography
          size='md'
          color='text-neutral-surface-100'
          className='max-w-[250px] sm:max-w-full truncate'
        >
          {value}
        </Typography>
        <Row className='gap-xs w-fit'>
          <CryptoQrCodeButton
            value={value}
            networkName={networkName}
            networkBadge={networkBadge}
            networkIcon={networkIcon}
          />
          {isCopyable && (
            <CopyButton
              text={value ?? ''}
              nonActiveTitle={t('common_copy')}
              activeMessageTitle={t('common_copied')}
            />
          )}
        </Row>
      </Row>
      {description && (
        <Typography size='xs' color='text-neutral-surface-100'>
          {description}
        </Typography>
      )}
    </Col>
  )
}
